import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type RolesState = {
    dataAllRoles: RoleType[];
    pagination: PaginationAPI;
    hasInitialLoad: boolean;
};

export const rolesInitialState: RolesState = {
    dataAllRoles: [],
    pagination: {
        pageNumber: Pagination.pageNumber,
        totalPages: 0,
        totalElements: 0,
        pageSize: Pagination.pageSize,
    },
    hasInitialLoad: false,
};

const slice = createSlice({
    name: 'roles',
    initialState: rolesInitialState,
    reducers: {
        setListRolesAction(
            state,
            {
                payload,
            }: PayloadAction<{
                data: RoleType[];
                pagination?: PaginationAPI;
                append?: boolean;
            }>,
        ) {
            if (payload.append) {
                state.dataAllRoles = [...state.dataAllRoles, ...payload.data];
            } else {
                state.dataAllRoles = payload.data;
            }
            state.pagination = payload.pagination || state.pagination;
            state.hasInitialLoad = true;
        },
    },
});

export const { setListRolesAction } = slice.actions;
export default slice.reducer;
